import { render, staticRenderFns } from "./License.vue?vue&type=template&id=5f7ed726"
var script = {}
import style0 from "./License.vue?vue&type=style&index=0&id=5f7ed726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports